// mainAtoms.ts
import { atom } from 'jotai'

export const mainActiveIndexAtom = atom<number>(0)